import React,  { useRef } from "react";
import { CopyBlock, dracula } from "react-code-blocks";

import gimpLoading from "../../assets/gimp-loading.png";
import gimpNewFile from "../../assets/gimp-new-file.png";
import gimpInterface from "../../assets/Gimp_interface.jpg";

import gimpTemplates from "../../assets/gimp_templates.jpg";
import gimpLayers from "../../assets/gimp_layers.png";
import gimpBrushSettings from "../../assets/gimp_brush_settings.jpg";
import inkscapeInterface from "../../assets/inkscape_interface.jpg";
import inkscapeDownload from "../../assets/inkscape-download.png";
import inkscapeTraceBitmap from "../../assets/inkscape-trace-bitmap.png";
import inkscapeVectorized from "../../assets/inkscape-vectorized.png";
import inkscapeZoomed from "../../assets/inkscape-zoomed.png";
import freecadInterface from "../../assets/freecad-interface.png";
import freecadDownload from "../../assets/freecad-download.png";
import freecadDarkMode from "../../assets/freecad-dark-mode.png";
import fusion360Interface from "../../assets/fusion360-interface.png";
import fusion360NewSketch from "../../assets/fusion360-new-sketch.png";
import fusion360DrawCircle from "../../assets/fusion360-draw-circle.png";
import fusion360Extrude from "../../assets/fusion360-extrude.png";
import headerImage from "../../assets/cad_software_header.png";
import fusion360cylinder from "../../assets/fusion360-final-object.png";
import w21 from "../../assets/w2-1.png";
import w22 from "../../assets/w2-2.png";
import w23 from "../../assets/w2-3.png";
import w24 from "../../assets/w2-4.png";
import w25 from "../../assets/w2-5.png";
import w26 from "../../assets/w2-6.png";
import w27 from "../../assets/w2-7.png";
import w28 from "../../assets/w2-8.png";
import w29 from "../../assets/w2-9.png";
import w210 from "../../assets/w2-10.png";
import w211 from "../../assets/w2-11.png";
import w212 from "../../assets/w2-12.png";
import w213 from "../../assets/w2-13.png";
import w214 from "../../assets/w2-14.png";
import w215 from "../../assets/w2-15.png";
import w216 from "../../assets/w2-16.png";
import w217 from "../../assets/w2-17.png";
import w218 from "../../assets/w2-18.jpg";
import w219 from "../../assets/w2-19.jpg";
import w220 from "../../assets/w2-20.jpg";
import w221 from "../../assets/w2-21.jpg";
import w222 from "../../assets/w2-22.jpg";
import w223 from "../../assets/w2-23.jpg";
import w224 from "../../assets/w2-24.jpg";
import w225 from "../../assets/w2-25.jpg";
import w226 from "../../assets/w2-26.jpg";
import w227 from "../../assets/w2-27.jpg";
import w228 from "../../assets/w2-28.jpg";
import w229 from "../../assets/w2-29.jpg";
import w230 from "../../assets/w2-30.png";
import w231 from "../../assets/w2-31.png";
import w232 from "../../assets/w2-32.png";
import ImageMagick from "../../assets/ImageMagick.png";
import smallVideo from '../../assets/small_video.mp4';
import video1 from '../../assets/video_1.jpg';
import video2 from '../../assets/video_2.jpg';
import videocompression from '../../assets/video_compression.jpg';



//import fusion360cylinder from "../../assets/fusion360_cylinder.png";
const Assignment3 = () => {
  const ref2DSoftware = useRef(null);
  const ref3DSoftware = useRef(null);
  const refModelling = useRef(null);
  const refFileCompressing = useRef(null);

  const scrollToSection = (ref) => {
    ref.current?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="container mx-auto my-8 px-5 max-w-3xl bg-gray-100 p-8 rounded-lg shadow-md">
      {/* Header */}
      <div className="relative mb-8">
        <img
          src={headerImage}
          alt="Header"
          className="w-full h-64 object-cover rounded-lg shadow-md  object-cover filter grayscale brightness-75"
        />
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black to-transparent p-4 rounded-b-lg">
          <h1 className="text-4xl font-bold text-bg-secondary"  style={{ textShadow: '2px 2px 4px rgba(0, 0, 0, 1)' }}>2. Week - Computer-Aided Design</h1>
          <p className="text-gray-300 mt-2">Published on: <span className="font-semibold">February 4, 2025</span></p>
          <div className="mt-4 flex space-x-4">
         {/* Navigation Links */}
      <div className="mt-4 flex space-x-4">
        <button onClick={() => scrollToSection(ref2DSoftware)} className="text-white bg-secondary px-3 py-1 rounded hover:bg-secondary">
          2D Software
        </button>
        <button onClick={() => scrollToSection(ref3DSoftware)} className="text-white bg-secondary px-3 py-1 rounded hover:bg-secondary">
          3D Software
        </button>
        <button onClick={() => scrollToSection(refModelling)} className="text-white bg-secondary px-3 py-1 rounded hover:bg-secondary">
          Modeling
        </button>
        <button onClick={() => scrollToSection(refFileCompressing)} className="text-white bg-secondary px-3 py-1 rounded hover:bg-secondary">
          File Compressing
        </button>
      </div>
          </div>
        </div>
      </div>
      
      <h2 className="text-3xl font-bold text-center mb-6">Week 2: Computer-Aided Design</h2>
      <p className="text-justify text-gray-700 mb-6">
        This week, I explored various 2D and 3D modeling software tools to understand their features and applications in digital fabrication. The goal was to get hands-on experience, test different software options, and evaluate which ones best suit my needs for future projects.
      </p>
      <div ref={ref2DSoftware}>
      <h3 className="text-2xl font-bold text-center mb-4">Exploring 2D Design Software</h3>
   

      <h4 className="text-xl font-bold mb-2">GIMP – Open-Source Image Editing</h4>
      <p>GIMP is a powerful and versatile raster graphics editor that serves as a great alternative to Photoshop. It is widely popular in the Linux community but is also available for Windows and macOS.</p>
      <img src={gimpLoading} alt="GIMP Loading Screen" className="my-4 mx-auto rounded shadow-md" />
      <p>Upon launching, GIMP greets you with a clean and professional interface.</p>
      <img src={gimpInterface} alt="GIMP Interface" className="my-4 mx-auto rounded shadow-md" />
      <p>Creating a new file is simple – just go to <strong>File → New</strong>, where you can define the canvas size and resolution.</p>
      
      <p>GIMP provides a range of useful templates and allows users to customize resolution settings.</p>
      <img src={gimpTemplates} alt="GIMP Templates" className="my-4 mx-auto rounded shadow-md" />
      <p>It supports multiple layers, making complex image editing more efficient.</p>
      <img src={gimpLayers} alt="GIMP Layers" className="my-4 mx-auto rounded shadow-md" />
      <p>Additionally, GIMP includes advanced brush settings for digital painting and fine adjustments.</p>
      <img src={gimpBrushSettings} alt="GIMP Brush Settings" className="my-4 mx-auto rounded shadow-md" />

      <h4 className="text-xl font-bold mt-6 mb-2">Inkscape – Vector Graphics Editing</h4>
      <p>Inkscape is a widely used vector graphics editor, perfect for creating designs for laser cutting and vinyl cutting.</p>
      <img src={inkscapeInterface} alt="Inkscape Interface" className="my-4 mx-auto rounded shadow-md" />
      <p>Downloading and installing Inkscape is straightforward from the official website.</p>
      <img src={inkscapeDownload} alt="Inkscape Download" className="my-4 mx-auto rounded shadow-md" />
      <p>One of Inkscape’s standout features is its ability to convert raster images into vector paths using the <strong>Trace Bitmap</strong> tool.</p>
      <img src={inkscapeTraceBitmap} alt="Inkscape Trace Bitmap" className="my-4 mx-auto rounded shadow-md" />
      <p>Here’s a zoomed-in comparison of an original raster image and its vectorized version.</p>
      <img src={inkscapeZoomed} alt="Inkscape Zoomed Image" className="my-4 mx-auto rounded shadow-md" />
      <p>Once converted, the new vector image can be scaled infinitely without losing quality.</p>
      <img src={inkscapeVectorized} alt="Inkscape Vectorized Image" className="my-4 mx-auto rounded shadow-md" />


      {/* 3D Software Section */}
      <div ref={ref3DSoftware}>
      <h3 className="text-2xl font-bold text-center mt-8 mb-4">Exploring 3D Design Software</h3>
      <h4 className="text-xl font-bold mb-2">FreeCAD – Open-Source 3D Modeling</h4>
      <p>FreeCAD is a free parametric 3D modeler designed for engineering and product design.</p>
      <img src={freecadInterface} alt="FreeCAD Interface" className="my-4 mx-auto rounded shadow-md" />
      <p>It’s available for multiple operating systems and easy to install.</p>
      <img src={freecadDownload} alt="FreeCAD Download" className="my-4 mx-auto rounded shadow-md" />
      <p>The software also features a dark mode, making it more comfortable for extended design sessions.</p>
      <img src={freecadDarkMode} alt="FreeCAD Dark Mode" className="my-4 mx-auto rounded shadow-md" />
      <p>Users can export models in different formats, supporting a variety of fabrication techniques.</p>
      </div>

      <h4 className="text-xl font-bold mt-6 mb-2">Fusion 360 – Professional CAD Tool</h4>
      <p>Fusion 360 is a cloud-based CAD software that integrates modeling, simulation, and manufacturing tools.</p>
      <img src={fusion360Interface} alt="Fusion 360 Interface" className="my-4 mx-auto rounded shadow-md" />
      <p>The design process begins with sketching a 2D outline.</p>
      <img src={fusion360NewSketch} alt="Fusion 360 New Sketch" className="my-4 mx-auto rounded shadow-md" />
      <p>Basic shapes can be dimensioned and later extruded into 3D models. In the top left corner you can click on the field with the green plus to create a sketch. </p>
      <img src={fusion360DrawCircle} alt="Fusion 360 Draw Circle" className="my-4 mx-auto rounded shadow-md" />
      <p>This can then be used to create 2D sketches, which can then be transformed into 3D objects. For example, you can create a circle and enter the diameter in the field. You can then extrude this to obtain a 3D model. First, however, you must click on finish sketch.  </p>
      <img src={fusion360Extrude} alt="Fusion 360 Extrude" className="my-4 mx-auto rounded shadow-md" />
      <p>You can now make a few settings in the menu and then extrude the object. We now have a cylinder. </p>
      <img src={fusion360cylinder} alt="Fusion 360  Image" className="my-4 mx-auto rounded shadow-md" />


      <h3 className="text-2xl font-bold text-center mb-4">Final Thoughts on 2D and 3D Modeling Tools</h3>
      <p className="text-justify text-gray-700 mb-6">
        Both 2D and 3D modeling software play a crucial role in digital fabrication, each serving different but complementary purposes. 2D software like Inkscape and GIMP is essential for creating vector-based designs, which are particularly useful for laser cutting, vinyl cutting, and graphic design. These tools allow precise control over outlines, colors, and layers, making them invaluable for preparing fabrication-ready files.
      </p>
      <p className="text-justify text-gray-700 mb-6">
        On the other hand, 3D modeling software such as FreeCAD and Fusion 360 enables designers to create complex three-dimensional objects with accuracy and detail. FreeCAD, as an open-source tool, provides a versatile and customizable environment for parametric modeling, making it a great choice for mechanical design and engineering applications. Fusion 360, with its cloud-based integration and extensive toolset, is widely used for prototyping, manufacturing, and even generative design.
      </p>
      <p className="text-justify text-gray-700 mb-6">
        Mastering both types of software expands creative possibilities and allows for seamless transitions between different fabrication techniques. Whether sketching a basic concept, designing precise 2D cut files, or engineering a fully realized 3D object, these tools empower makers to bring their ideas to life. As I continue my journey in the Fab Academy, I look forward to refining my skills and integrating these tools into my future projects.
      </p>
    </div>




          {/* Modelling Section */}
          <div ref={refModelling}>
        <h3 className="text-2xl font-bold text-center mt-8 mb-4">Modeling</h3>
        <h4 className="text-xl font-bold text-center mt-4 mb-4">2D-Modeling</h4>
        <p className="text-justify text-gray-700 mb-6">
          One way to produce the bearing blocks for the drive of my final project is to design them in 2D and cut them out with the metal laser cutter.  For this reason, I will first model the bearing blocks in Inkscape. For my final project, I need two bearing blocks, which accommodate a 13mm ball bearing and connect the two shafts to each other via a toothed belt. I therefore need a bearing block to which the stepper motor is attached and the drive shaft for the tires, as well as a counterpart that receives the drive shaft.
        </p>

        <img src={w21} alt="Description of w2-1" className="my-4 mx-auto rounded shadow-md" />
        <p className="text-justify text-gray-700 mb-6">The dimensions should be 130mm x 60mm. I also need two recesses. One for the ball bearing and one for the motor shaft. </p>
<img src={w23} alt="Description of w2-3" className="my-4 mx-auto rounded shadow-md" />
<p className="text-justify text-gray-700 mb-6">After I have drawn the first circle and entered the dimensions 6.5 mm radius Rx and Ry at the top, I draw the second circle with the diameter of the drive shaft. The Nema17 stepper motor has an outer shaft diameter of 8mm.</p>
<p className="text-justify text-gray-700 mb-6">Next, I want to center the circles. To do this, I first mark all the elements. </p>
<img src={w28} alt="Description of w2-8" className="my-4 mx-auto rounded shadow-md" />
<p className="text-justify text-gray-700 mb-6">Next, I use the align tool and select center on horizontal axis.</p>
<img src={w26} alt="Description of w2-6" className="my-4 mx-auto rounded shadow-md" />
<img src={w29} alt="Description of w2-9" className="my-4 mx-auto rounded shadow-md" />
<p className="text-justify text-gray-700 mb-6">Now the holes with which the motor block is attached are still missing. The frame size of the Nema17 is 42mmx42mm. In the data sheet I found out that the distance between the screw holes is 31mm.

In addition, M3 is used for the screws. I looked in the ISO thread table DIN 13, T1 and found that the through hole for an M3 fine thread is 3.2mm. So I draw 4 holes with the corresponding dimensions. 
 </p>
<img src={w210} alt="Description of w2-10" className="my-4 mx-auto rounded shadow-md" />
<p className="text-justify text-gray-700 mb-6">Next, I draw a circle with a diameter of 32mm around the elements for orientation.</p>
<img src={w211} alt="Description of w2-11" className="my-4 mx-auto rounded shadow-md" />
<p className="text-justify text-gray-700 mb-6">The distribution tool helps to distribute the through holes accordingly on the auxiliary circle. Next, the circle that we needed to distribute the objects is deleted. </p>
<img src={w213} alt="Description of w2-13" className="my-4 mx-auto rounded shadow-md" />
<p className="text-justify text-gray-700 mb-6">I group the elements so that they can no longer move in the future. A little hint: Unlike most programs, Inkscape uses Shift to select multiple objects. </p>
<img src={w215} alt="Description of w2-15" className="my-4 mx-auto rounded shadow-md" />
<p className="text-justify text-gray-700 mb-6"></p>
<img src={w216} alt="Description of w2-16" className="my-4 mx-auto rounded shadow-md" />
<p className="text-justify text-gray-700 mb-6">When drawing, I noticed the error that the motor should not float in the middle of the bearing block, but must be placed at the bottom. So I move the group and save the file as .svg. </p>
<img src={w217} alt="Description of w2-17" className="my-4 mx-auto rounded shadow-md" />


<h4 className="text-xl font-bold text-center mt-4 mb-4">3D-Modeling</h4>
<p className="text-justify text-gray-700 mb-6"> Next, I modeled the second bearing block in Fusion 360 3D. This has the advantage that I can simply print it out for testing and don't have to use so much aluminum for the first prototypes. 
I start by creating a sketch in Fusion and create a square measuring 600 mm x 700 mm.</p>

<img src={w218} className="my-4 mx-auto rounded shadow-md" />
<p className="text-justify text-gray-700 mb-6">Next, I press Finish Sketch to finish the sketch.  </p>
<img src={w219} className="my-4 mx-auto rounded shadow-md" />
<p className="text-justify text-gray-700 mb-6"> Then I extrude the cuboid. </p>
<img src={w220} className="my-4 mx-auto rounded shadow-md" />
<p className="text-justify text-gray-700 mb-6">The next step is to model the drill holes in the lower part of the block. To do this, I switch back to the sketch view, select the underside of the block as the basis and draw a guide line in the middle. I create a circle and would now like to have it on both sides of the block, which is why I mirror it on the auxiliary line. </p>
<img src={w221} className="my-4 mx-auto rounded shadow-md" />
<p className="text-justify text-gray-700 mb-6">After removing the auxiliary line, it looks like this. </p>
<img src={w222} className="my-4 mx-auto rounded shadow-md" />
<p className="text-justify text-gray-700 mb-6">Then I finish the sketch again and cut out the drill holes with the Extrude tool at a depth of 15mm. </p>
<img src={w223} className="my-4 mx-auto rounded shadow-md" />
<p className="text-justify text-gray-700 mb-6">The model then looks like this:  </p>
<img src={w224} className="my-4 mx-auto rounded shadow-md" />
<p className="text-justify text-gray-700 mb-6">Next, we take care of the recess for the ball bearing. Since the ball bearing only has a depth of 5mm and we have a material thickness of 10mm, we have to draw a circle with 13mm and drill 5mm deep.  </p>
<img src={w225} className="my-4 mx-auto rounded shadow-md" />
<p className="text-justify text-gray-700 mb-6">We want to leave a margin of 2mm. To do this, we select the same center point and draw a circle with a diameter of 11mm, which we then drill through to the full thickness of the material.  </p>
<img src={w226} className="my-4 mx-auto rounded shadow-md" />
<img src={w227} className="my-4 mx-auto rounded shadow-md" />
<img src={w228} className="my-4 mx-auto rounded shadow-md" />
<img src={w229} className="my-4 mx-auto rounded shadow-md" />

<img src={w230} className="my-4 mx-auto rounded shadow-md" />
<p className="text-justify text-gray-700 mb-6">Our model for the bearing block is finished.  </p>


<h4 className="text-xl font-bold text-center mt-4 mb-4">3D modeling of the final project</h4>
<p className="text-justify text-gray-700 mb-6">The two parts of the final project shown here are only small components. At the same time, I tried to construct the robot in Fusion 360 for the first time.  </p>
<img src={w231} className="my-4 mx-auto rounded shadow-md" />
<p className="text-justify text-gray-700 mb-6">I started with the construction of the base plate, in which I made two cut-outs for the wheels and four screw holes for attaching a 360-degree rotating wheel. I positioned 8 slots on the edge into which the 3D printed cover will later be inserted. I also added 4 threaded rods to connect the two plates together.
</p>
<img src={w232} className="my-4 mx-auto rounded shadow-md" />
<p className="text-justify text-gray-700 mb-6">A second plate with the same slots and holes for the threaded rods was then placed on the threaded rods. 
The dome was then mounted on top of this and a compartment inserted. </p>
</div>

    


    {/* File Compressing Section */}
    <div ref={refFileCompressing}>
    <h3 className="text-2xl font-bold text-center mt-8 mb-4">File Compressing</h3>
    <h3 className="text-xl font-bold text-center mt-8 mb-4">Image Compressing</h3>
    <p className="text-justify text-gray-700 mb-6">Another task for this week is to document how to compress files and optimize for web use.</p>
    <p className="text-justify text-gray-700 mb-6">ImageMagick is a powerful command-line tool that allows you to process and manipulate images, including resizing, converting, and optimizing them. It supports a wide range of formats, including PNG, JPG, GIF, and TIFF.</p>
    <p className="text-justify text-gray-700 mb-6">You can download ImageMagick on https://imagemagick.org/</p> 
    <img src={ImageMagick}  className="my-4 mx-auto rounded shadow-md" />
    <p className="text-justify text-gray-700 mb-6"> To check whether the installation succeeded you can enter the following command in your cmd: </p>

    <CopyBlock
              text="magick -version"
              language="bash"
              showLineNumbers={false}
              theme={dracula}
              codeBlock
            />

<h4 className="text-l font-bold text-left mt-4 mb-4"> Preparing Your Image Folder</h4>
<p>Before resizing, ensure:</p>
<ul>
  <li>All images are stored in a specific folder (e.g., <code>input_images/</code>).</li>
  <li>You have created an output folder (e.g., <code>output_images/</code>).</li>
</ul>
<p>You can create an output folder using:</p>
<CopyBlock
              text="mkdir output_images"
              language="bash"
              showLineNumbers={false}
              theme={dracula}
              codeBlock
            />
<h4 className="text-l font-bold text-left mt-4 mb-4">Resizing </h4>

<p>To resize  all images to 50% of their original size run: </p> 

<CopyBlock
              text="mogrify -resize 50% -path output_images/ input_images/*.png"
              language="bash"
              showLineNumbers={false}
              theme={dracula}
              codeBlock
            />

<h4 className="text-l font-bold text-left mt-4 mb-4">Resize All Images to a Fixed Width:  </h4>

<p>Resize all images to a fixed width of 800 pixels while maintaining aspect ratio: </p> 

<CopyBlock
              text="mogrify -resize 800 -path output_images/ input_images/*.jpg"
              language="bash"
              showLineNumbers={false}
              theme={dracula}
              codeBlock
            />

<h4 className="text-l font-bold text-left mt-4 mb-4">Convert all images to JPEG format while resizing them:</h4>

<CopyBlock
              text="mogrify -resize 1024x768 -format jpg -path output_images/ input_images/*.png"
              language="bash"
              showLineNumbers={false}
              theme={dracula}
              codeBlock
            />


<p>This command: Resizes all images to 1024x768 pixels and converts PNG Files into JPEG format. </p>
<h3 className="text-xl font-bold text-center mt-8 mb-4">Video Compressing</h3>
<h2 className="text-3xl font-bold text-center mb-6">Video Compression with FFmpeg</h2>
<p className="text-justify text-gray-700 mb-6">
  To optimize storage and improve loading times, I compressed my video using <strong>FFmpeg</strong>. Below is the step-by-step process I followed.
</p>

<h3>1. Installing FFmpeg</h3>
<p className="text-justify text-gray-700 mb-6">
  First, I ensured that FFmpeg was installed on my system. I checked this by running the following command in the terminal:
</p>

<CopyBlock
              text="ffmpeg -version"
              language="bash"
              showLineNumbers={false}
              theme={dracula}
              codeBlock
            />
<p> - -</p>

<h3>2. Compressing the Video</h3>
<p className="text-justify text-gray-700 mb-6">
  To reduce the file size while maintaining good quality, I used the following command:
</p>
<CopyBlock
              text="ffmpeg -i .\original_video.mp4 -vcodec libx264 -crf 28 small_video.mp4"
              language="bash"
              showLineNumbers={false}
              theme={dracula}
              codeBlock
            />

<p className="text-justify text-gray-700 mb-6">
  - <strong>-i input_video.mp4</strong>: Specifies the input file. <br/>
  - <strong>-vcodec libx264</strong>: Uses the H.264 codec for efficient compression. <br/>
  - <strong>-crf 28</strong>: Sets the quality (lower values = higher quality, 28 is a good balance). <br/>
  - <strong>output_video.mp4</strong>: The name of the compressed file.
</p>
<img src={videocompression} alt="FFmpeg Compression Process" className="my-4 mx-auto rounded shadow-md" />

<h3>4. Comparing the File Sizes</h3>
<p className="text-justify text-gray-700 mb-6">
  After compression, I compared the original and new file sizes to see the reduction.
</p>

<img src={video1} alt="File Size Comparison" className="my-4 mx-auto rounded shadow-md" />
<img src={video2} alt="File Size Comparison" className="my-4 mx-auto rounded shadow-md" />
<h3>5. Verifying the Output Quality</h3>
<p className="text-justify text-gray-700 mb-6">
  Finally, I played the compressed video to ensure that the quality was acceptable:
</p>
<video controls className="my-4 mx-auto rounded shadow-md">
  <source src={smallVideo} type="video/mp4" />
</video>



    <h3 className="text-xl font-bold text-center mt-8 mb-4">Downloads</h3>
    <ul>
  <li><a href="https://fabacademy.org/2025/labs/bottrop/students/annasophia-brokuf/files/bearing_block.step" download>📎Download Bearing Block 2D</a></li>
  <li><a href="https://fabacademy.org/2025/labs/bottrop/students/annasophia-brokuf/files/bearing_block.svg" download>📎 Download Bearing Block 3D</a></li>
  <li><a href="https://fabacademy.org/2025/labs/bottrop/students/annasophia-brokuf/files/Final_Project_Draft.step" download>📎Download Final Project Draft </a></li>
</ul>


  </div>



  </div>
  );
};

export default Assignment3;
